import "./styles/main.scss"
import Atom from "./components/Atom.svelte"
import { isApp } from "$lib/helpers/platform"

// enable this when creating an atom for the article template
// import '$lib/helpers/resizeFrame';

// create scrollbar width CSS variable
import "$lib/helpers/scrollbarWidth"

import { hydrate } from "svelte"

let app

app = hydrate(Atom, {
  target: document.getElementById("map"),
  props: {
    name: "map",
    // Use local sample for dev; switch to Guardian URL for production
    feedUrl: "https://interactive.guim.co.uk/26/03/19-oz-narelle-cyclone/new_nt_cyclone-warning-tracker-map.json",
  },
})

export default app
